import {
    AssertionFraudResult,
    FormattedAssertionFraudResult
} from "@idw-types/data/assertion-fraud-result";
import { Assertion, RiskLevel } from "@idw-types/data/reference-data/generic";

export const formatAssertionFraudResults = (
    assertionFraudResults: Array<AssertionFraudResult>,
    assertions: Array<Assertion>,
    riskLevels: Array<RiskLevel>
): Array<FormattedAssertionFraudResult> => {
    return assertionFraudResults.map(result => formatAssertionFraudResult(result, assertions, riskLevels));
};

export const formatAssertionFraudResult = (
    assertionFraudResult: AssertionFraudResult,
    assertions: Array<Assertion>,
    riskLevels: Array<RiskLevel>
): FormattedAssertionFraudResult => {
    const assertion = assertions.find(a => a.id === assertionFraudResult.assertionID);
    const riskLevel = riskLevels.find(rl => rl.id === assertionFraudResult.riskLevelID);

    return {
        assertion: assertion,
        claimStatus: assertionFraudResult.claimStatus,
        finalPolicyDecision: assertionFraudResult.finalPolicyDecision,
        id: assertionFraudResult.id,
        riskLevel: riskLevel,
        totalCount: assertionFraudResult.totalCount
    };
};